<template>
  <f7-page class="main-FrmOrderCompleteProducto-page">
    <template #fixed>
      <TheNavbar
        class="container-navbar"
        :nav-title="$t('commercialization.common.newSalesOrderLine')"
        back-btn-enable
        :back-callback="BackToMain"
      />
    </template>

    <div class="container-toolbar">
      <UCToolbar
        :key="toolbarKey"
        class="content-toolbar"
        :is-bottom="false"
        :data="dataTabbar"
        tabbar-link="1"
      >
        <template #tabs>
          <f7-tabs>
            <f7-tab
              id="tab-1"
              tab-active
            >
              <div class="content-toolbar__detail margin-left margin-right pt-3">
                <UCSearchEntityERP
                  ref="UCProducto"
                  :title="$t('common.product')"
                  :placeholder="$t('searchEntity.product.placeholder.searchByProduct')"
                  :search-text="$t('searchEntity.product.searchText')"
                  :search-cancellation-text="$t('searchEntity.product.searchCancellationText')"
                  :search-not-found-text="$t('searchEntity.product.searchNotFoundText')"
                  :procedure-for-search="productProcedure"
                  :property-entity-shown-input="['Nombre', 'Codigo']"
                  :property-entity-shown-list-title="['Nombre']"
                  :property-entity-shown-list-subtitle="['Codigo']"
                  :min-text-search="0"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  @selection="EventProductSelected"
                />
                <div class="display-flex">
                  <UCSearchEntityERP
                    ref="UCConfeccion"
                    class="w-95"
                    :title="$t('common.assembly')"
                    :placeholder="$t('searchEntity.assembly.placeholder.searchByAssembly')"
                    :search-text="$t('searchEntity.assembly.searchText')"
                    :search-cancellation-text="$t('searchEntity.assembly.searchCancellationText')"
                    :search-not-found-text="$t('searchEntity.assembly.searchNotFoundText')"
                    :procedure-for-search="confeccionProcedure"
                    :property-entity-shown-input="['Nombre', 'Codigo']"
                    :property-entity-shown-list-title="['Nombre']"
                    :property-entity-shown-list-subtitle="[
                      'Producto.Nombre',
                      'Envase.Nombre',
                      'Palet.Nombre',
                      'EnvasesPorPalet',
                    ]"
                    :pre-property-entity-shown-list-subtitle="[
                      `${$t('common.product')}: `,
                      `${$t('common.package')}: `,
                      `${$t('common.pallet')}: `,
                      `${$t('common.packagesSlashPallet')}: `,
                    ]"
                    :min-text-search="0"
                    :autofocus-on-deselection="true"
                    :auto-focus-on-empty-search-result="true"
                    @selection="EventConfeccionSelected"
                  />
                  <div
                    class="display-flex align-items-flex-end margin-left-half"
                    @click="isCommonPackagingPopupOpened = true"
                  >
                    <img
                      src="@/static/icons/ic_confection.svg"
                      height="46"
                      width="46"
                    >
                  </div>
                </div>
                <UCSearchEntityERP
                  ref="UCEnvase"
                  :title="$t('common.package')"
                  :placeholder="$t('searchEntity.container.placeholder.searchByContainer')"
                  :search-text="$t('searchEntity.container.searchText')"
                  :search-cancellation-text="$t('searchEntity.container.searchCancellationText')"
                  :search-not-found-text="$t('searchEntity.container.searchNotFoundText')"
                  :procedure-for-search="packagingProcedure"
                  :property-entity-shown-input="['Nombre', 'Codigo']"
                  :property-entity-shown-list-title="['Nombre']"
                  :property-entity-shown-list-subtitle="['Codigo']"
                  :min-text-search="0"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  @selection="EventEnvaseSelected"
                />

                <UCSearchEntityERP
                  ref="UCMarca"
                  :title="$t('common.brand')"
                  :placeholder="$t('searchEntity.brand.placeholder.searchByBrand')"
                  :search-text="$t('searchEntity.brand.searchText')"
                  :search-cancellation-text="$t('searchEntity.brand.searchCancellationText')"
                  :search-not-found-text="$t('searchEntity.brand.searchNotFoundText')"
                  :procedure-for-search="brandProcedure"
                  :property-entity-shown-input="['Nombre', 'Codigo']"
                  :property-entity-shown-list-title="['Nombre']"
                  :property-entity-shown-list-subtitle="['Codigo']"
                  :min-text-search="0"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  @selection="EventMarcaSelected"
                />

                <UCSearchEntityERP
                  ref="UCTipoPalet"
                  :title="$t('searchEntity.palletType.title.palletType')"
                  :placeholder="$t('searchEntity.palletType.placeholder.searchByPalletType')"
                  :search-text="$t('searchEntity.palletType.searchText')"
                  :search-cancellation-text="$t('searchEntity.palletType.searchCancellationText')"
                  :search-not-found-text="$t('searchEntity.palletType.searchNotFoundText')"
                  :procedure-for-search="paleProcedure"
                  :property-entity-shown-input="['Nombre', 'Codigo']"
                  :property-entity-shown-list-title="['Nombre']"
                  :property-entity-shown-list-subtitle="['Codigo']"
                  :min-text-search="0"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  @selection="EventTipoPaletSelected"
                />
                <div class="content-toolbar__detail--steppers display-flex">
                  <div class="margin-right">
                    <small class="display-flex justify-content-center text-color-metal-dark size-14">
                      {{ $t('common.packagesPerPallet') }}
                    </small>
                    <f7-stepper
                      ref="stepperPackagesRef"
                      fill
                      :min="0"
                      :max="100000000"
                      :value="numEnvases"
                      :disabled="doNotChangeNumberOfContainers"
                      @input="setBoxValue($event.target.value)"
                      @stepper:change="ChangeNumEnvases"
                      @click="selectInputContent($event, $refs.stepperPackagesRef)"
                    />
                  </div>
                  <div>
                    <small class="display-flex justify-content-center text-color-metal-dark size-14">
                      {{ $t('commercialization.common.palletsNumberShort') }}
                    </small>
                    <f7-stepper
                      ref="stepperPalletsRef"
                      fill
                      :min="0"
                      :value="numPalets"
                      @input="setPaletValue($event.target.value)"
                      @stepper:change="ChangeNumPalets"
                      @click="selectInputContent($event, $refs.stepperPalletsRef)"
                    />
                  </div>
                </div>
                <div class="content-toolbar__detail--price display-flex">
                  <div class="content-toolbar__detail--price__item margin-right w-100">
                    <f7-list>
                      <small class="display-flex justify-content-center text-color-metal-dark size-14">
                        {{ `${$t('common.price')} (${divisaSelected?.Simbolo ?? ''})` }}
                      </small>
                      <f7-list-input
                        ref="inputPriceRef"
                        type="Number"
                        :value="price"
                        @input="ChangePrice($event.target.value)"
                        @change="ChangePrice($event.target.value)"
                        @click="selectInputContent($event, $refs.inputPriceRef)"
                      />
                    </f7-list>
                  </div>
                  <div
                    :key="uniqueKey"
                    class="content-toolbar__detail--price__item w-100"
                  >
                    <f7-list>
                      <small class="display-flex justify-content-center text-color-metal-dark size-14 mb-1">{{ $t('common.pricePer') }}</small>
                      <f7-list-item
                        class="w-100"
                        :title="$t('common.pricePer')"
                        smart-select
                        :smart-select-params="{ openIn: 'popover' }"
                      >
                        <select
                          name="Precio por"
                          @change="SelectUnitMeasured($event.target.value)"
                        >
                          <option
                            v-for="unidad in unidadesMedida"
                            :key="unidad.Id"
                            :selected="setUnitMeasured(unidad)"
                            :value="unidad.Id"
                          >
                            {{ unidad.Codigo }}
                          </option>
                        </select>
                      </f7-list-item>
                    </f7-list>
                  </div>
                </div>
              </div>
            </f7-tab>
            <f7-tab
              id="tab-2"
            >
              <div class="content-toolbar__other margin-left margin-right pt-3">
                <div class="content-toolbar__other--obs-title text-color-metal-dark">
                  {{ $t('common.observations') }}
                </div>
                <f7-text-editor
                  :resizable="true"
                  name="textarea"
                  :placeholder="$t('common.observations')"
                  mode="popover"
                  :buttons="['bold', 'italic', 'underline', 'strikeThrough']"
                  :value="observations"
                  @texteditor:change="(value) => observations = value"
                />

                <UCSearchEntityERP
                  ref="UCLote"
                  :title="$t('common.lot')"
                  :placeholder="$t('searchEntity.lot.placeholder.searchByLot')"
                  :search-text="$t('searchEntity.lot.searchText')"
                  :search-cancellation-text="$t('searchEntity.lot.searchCancellationText')"
                  :search-not-found-text="$t('searchEntity.lot.searchNotFoundText')"
                  :procedure-for-search="lotProcedure"
                  :property-entity-shown-input="['Codigo']"
                  :property-entity-shown-list-title="['Codigo']"
                  :min-text-search="0"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  @selection="EventLoteSelected"
                />

                <UCSearchEntityERP
                  ref="UCAlmacenOrigen"
                  :title="$t('common.originWarehouse')"
                  :placeholder="$t('searchEntity.warehouse.placeholder.searchByWarehouse')"
                  :search-text="$t('searchEntity.warehouse.searchText')"
                  :search-cancellation-text="$t('searchEntity.warehouse.searchCancellationText')"
                  :search-not-found-text="$t('searchEntity.warehouse.searchNotFoundText')"
                  :procedure-for-search="warehouseProcedure"
                  :property-entity-shown-input="['Nombre', 'Codigo']"
                  :property-entity-shown-list-title="['Nombre']"
                  :property-entity-shown-list-subtitle="['Codigo']"
                  :min-text-search="0"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  @selection="EventAlmacenSelected"
                />
                <f7-list
                  v-if="showDataComplementary"
                  accordion-list
                  inset
                  class="container-complementary-data"
                >
                  <f7-list-item
                    accordion-item
                    :title="$t('common.supplementaryData')"
                  >
                    <f7-accordion-content>
                      <div>
                        <UCDatosComplementarios
                          :default-datos-complementarios="defaultDC != null ? salesOrderLine.DatosComplementarios : []"
                          :activo="true"
                          :entidad-seleccionada="{ Id: salesOrderLine == null ? 0 : salesOrderLine.Id }"
                          :edition="true"
                          tipo-entidad-seleccionada="LineaPedidoVenta"
                          @change-complementary-data="EventChangeComplementayData"
                        />
                      </div>
                    </f7-accordion-content>
                  </f7-list-item>
                </f7-list>
              </div>
            </f7-tab>
          </f7-tabs>
        </template>
      </UCToolbar>
    </div>
    <div class="content-button">
      <f7-button
        class="content-button__save"
        fill
        @click="PressBtnNext"
      >
        {{ $t('common.save') }}
      </f7-button>
    </div>
    <!-- common packaging -->
    <f7-popup v-model:opened="isCommonPackagingPopupOpened">
      <PCFrequentSalesOrderPackaging
        v-if="isCommonPackagingPopupOpened"
        :client-id="actualOrder.Cliente.Id"
        @selected-packaging="selectedPackaging"
      />
    </f7-popup>

    <InfoSheet
      :state="infoSheetParams.state"
      :opened="infoSheetParams.opened"
      :title="infoSheetParams.title"
      :subtitle1="infoSheetParams.subtitle1"
      @closed="infoSheetParams.opened = false"
    />
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { useAppOrdersStore } from '@/js/stores/appOrders';
import TheNavbar from '@/components/TheNavbar.vue';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import InfoSheet from '@/components/common/InfoSheet.vue';
import { HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import UCToolbar from '@/components/common/UCToolbar.vue';
import { Log } from '@/js/common/HIDebuggingSupport';
import APIErp, { callExecuteSPERP, callFetchWarehousesForEnterpriseGroupsAndLocations } from '@/js/services/APIErp';
import UCDatosComplementarios from '@/components/common/UCDatosComplementarios.vue';
import { deepToRaw } from '@/js/utils/deepToRaw';
import { f7 } from 'framework7-vue';
import { sleep } from '@/js/utils/sleep';
import PCFrequentSalesOrderPackaging from '@/components/production/commercialization/salesOrders/PCFrequentSalesOrderPackaging.vue';
import { TipoBloqueo } from '@/js/common/enum';
import {
  nextTick,
} from 'vue';

/**
 * @import {
 * InfoSheetState,
 * SPApp,
 * } from '@erpagroapp/types' */

export default {
  name: 'FrmOrderCompleteProducto',
  components: {
    TheNavbar,
    UCSearchEntityERP,
    UCToolbar,
    UCDatosComplementarios,
    PCFrequentSalesOrderPackaging,
    InfoSheet,

  },
  props: {
    nuevoPedido: { type: Boolean, default: true },
    palletMixed: { type: Boolean, default: false }, // Añadir linea para el palet mixto si esta en true y añadir una linea completa si esta en falso
  },

  data() {
    return {
      observations: null,
      productoSelected: null,
      envaseSelected: null,
      tipoPaletSelected: null,
      almacenSelected: null,
      loteSelected: null,
      marcaSelected: null,
      datosComp: null,
      id: 0,
      idTempral: null,
      confeccionSelected: null,
      numEnvases: 0,
      numPalets: 0,
      price: 0,
      unidadesMedida: [],
      unidadMedidaSelected: null,
      uniqueKey: 0,
      divisaSelected: null,
      defaultDC: null,
      showDataComplementary: true,
      isCommonPackagingPopupOpened: false,
      dataTabbar: [
        {
          title: this.$t('common.details').toUpperCase(),
          badge: '',
          href: '',
          tablink: '1',
        },
        {
          title: this.$t('common.otherPl').toUpperCase(),
          badge: '',
          href: '',
          tablink: '2',
        },
      ],
      doNotChangeNumberOfContainers: false,
      commonPackagingSelected: false, // se usa para controlar que al seleccionar una confeccion habitual, a la hora de saltar el evento de seleccion de proudcto no ejecute la asignacion por composicion del articulo
      infoSheetParams: {
        opened: false,
        subtitle1: '',
        title: '',
        /** @type {InfoSheetState} */
        state: 'CAUTION',
      },
    };
  },

  computed: {
    ...mapState(useAppConfigStore, ['userEnviroment']),

    ...mapState(useAppOrdersStore, [
      'dataClient',
      'salesOrderLine',
    ]),

    ...mapWritableState(useAppOrdersStore, [
      'estadoLineaEditada',
      'estadoLineaCopiada',
      'mixedOrderLines',
      'actualOrder',
    ]),
    toolbarKey() {
      return 'main-FrmOrderCompleteProducto-page'; // dentificador único para cada toolbar
    },
    confeccionProcedure() {
      return /** @satisfies {SPApp} */ ({
        NombreSP: 'APPERPAGRO_ConfeccionXIdClienteXIdEmpresa',
        Parametros: [
          { NombreParametro: 'filtro', Valor: 'q:' },
          { NombreParametro: 'idCliente', Valor: this.dataClient?.Id ?? '' },
          { NombreParametro: 'idArticulo', Valor: this.productoSelected?.Id ?? 0 },
          { NombreParametro: 'idEmpresa', Valor: this.userEnviroment.EntornoDeTrabajo.Empresa?.Id ?? 0 },
          { NombreParametro: 'fechaComprobacionBloqueos', Valor: new Date() },
        ],
        EntidadMapear: 'Comun.ConfeccionJSON',
      });
    },
    warehouseProcedure() {
      return /** @satisfies {SPApp} */ ({
        NombreSP: 'APPERPAGRO_AlmacenesXIdGrupoEmpresarialXUbicacion',
        Parametros: [
          { NombreParametro: 'filtro', Valor: 'q:' },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          { NombreParametro: 'idsUbicacion', Valor: '' },
        ],
        EntidadMapear: 'AlmacenJSON',
      });
    },
    productProcedure() {
      return /** @satisfies {SPApp} */ ({
        NombreSP: 'APPERPAGRO_ArticulosXTipoArticulo',
        Parametros: [
          { NombreParametro: 'filtro', Valor: 'q:' },
          { NombreParametro: 'tipoArticulo', Valor: '2' },
          { NombreParametro: 'idEmpresa', Valor: this.userEnviroment.EntornoDeTrabajo.Empresa?.Id },
          { NombreParametro: 'fecha', Valor: new Date() },
          { NombreParametro: 'materiPrimaCheck', Valor: 0 },
        ],
        EntidadMapear: 'Comun.ArticuloJSON',
      });
    },
    packagingProcedure() {
      return /** @satisfies {SPApp} */ ({
        NombreSP: 'APPERPAGRO_ArticulosXTipoArticulo',
        Parametros: [
          { NombreParametro: 'filtro', Valor: 'q:' },
          { NombreParametro: 'tipoArticulo', Valor: '1' },
          { NombreParametro: 'idEmpresa', Valor: this.userEnviroment.EntornoDeTrabajo.Empresa?.Id },
          { NombreParametro: 'fecha', Valor: new Date() },
          { NombreParametro: 'materiPrimaCheck', Valor: 0 },
        ],
        EntidadMapear: 'Comun.ArticuloJSON',
      });
    },
    paleProcedure() {
      return /** @satisfies {SPApp} */ ({
        NombreSP: 'APPERPAGRO_ArticulosXTipoArticulo',
        Parametros: [
          { NombreParametro: 'filtro', Valor: 'q:' },
          { NombreParametro: 'tipoArticulo', Valor: '0' },
          { NombreParametro: 'idEmpresa', Valor: this.userEnviroment.EntornoDeTrabajo.Empresa.Id },
          { NombreParametro: 'fecha', Valor: new Date() },
          { NombreParametro: 'materiPrimaCheck', Valor: 0 },
        ],
        EntidadMapear: 'Comun.ArticuloJSON',
      });
    },
    brandProcedure() {
      return /** @satisfies {SPApp} */ ({
        NombreSP: 'APPERPAGRO_MarcasXIdGrupoEmpresarial',
        Parametros: [
          { NombreParametro: 'filtro', Valor: 'q:' },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: `${this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id}` },
        ],
        EntidadMapear: 'Comun.MarcaJSON',
      });
    },
    lotProcedure() {
      return /** @satisfies {SPApp} */ ({
        NombreSP: 'APPERPAGRO_LoteLineaXIdGrupoEmpresarial',
        Parametros: [
          { NombreParametro: 'filtro', Valor: 'q:' },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: `${this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id}` },
        ],
        EntidadMapear: 'Almacen.LoteJSON',
      });
    },

  },
  watch: {
    productoSelected: {
      handler() {
        this.actualizarPrecio();
      },
      deep: true,
    },
  },

  mounted() {
    this.StartComponent();
  },

  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      if (this.estadoLineaEditada) {
        this.commonPackagingSelected = true;
        this.productoSelected = this.salesOrderLine.Articulo;
        this.$refs.UCProducto.SelectEntity(this.productoSelected, true);
        this.envaseSelected = this.salesOrderLine.InfoEnvase;
        this.$refs.UCEnvase.SelectEntity(this.envaseSelected, true);
        this.tipoPaletSelected = this.salesOrderLine.InfoPale;
        this.$refs.UCTipoPalet.SelectEntity(this.tipoPaletSelected, true);
        this.almacenSelected = this.salesOrderLine.AlmacenOrigen;
        this.$refs.UCAlmacenOrigen.SelectEntity(this.almacenSelected, true);
        this.numEnvases = this.salesOrderLine.EnvasesPorPalet;
        this.numPalets = this.salesOrderLine.CantidadPales;
        this.price = this.salesOrderLine.Precio;
        this.id = this.salesOrderLine.Id;
        if (Object.hasOwn(this.salesOrderLine, 'IdTemporal')) {
          this.idTempral = this.salesOrderLine.IdTemporal;
        } else {
          this.idTempral = null;
        }
        this.defaultDC = this.salesOrderLine.DatosComplementarios;
        this.confeccionSelected = this.salesOrderLine.Confeccion;
        if (this.confeccionSelected !== null && this.confeccionSelected !== undefined) {
          this.$refs.UCConfeccion.SelectEntity(this.confeccionSelected, true);
        }
        this.marcaSelected = this.salesOrderLine.Marca;
        if (this.marcaSelected !== null && this.marcaSelected !== undefined) {
          this.$refs.UCMarca.SelectEntity(this.marcaSelected, true);
        }
        if (this.salesOrderLine.Observaciones != null && this.salesOrderLine.Observaciones !== undefined) {
          this.observations = this.salesOrderLine.Observaciones.Texto;
        }
        this.unidadMedidaSelected = this.salesOrderLine.PrecioPor;
        this.CargarUnidadesMedida();
        this.loteSelected = this.salesOrderLine.Lote;
        if (this.loteSelected !== null && this.loteSelected !== undefined) {
          this.$refs.UCLote.SelectEntity(this.loteSelected, true);
        }
        this.estadoLineaEditada = false;
      }
      if (this.estadoLineaCopiada /* && !this.palletMixed */) {
        this.id = 0;
        this.idTempral = null;
        this.estadoLineaCopiada = false;
      }
      this.GetDefaultCurrencies();
      this.GetDefaultWarehouse();
    },
    getPrice() {
      Log(this, this.getPrice.name);
      return Number(Number.parseFloat(5.55).toFixed(2));
    },
    ChangeNumEnvases(value) {
      this.numEnvases = value;
    },
    ChangeNumPalets(value) {
      this.numPalets = value;
    },
    SelectUnitMeasured(newUnit) {
      Log(this, this.SelectUnitMeasured.name);
      const newUnitNumber = Number(newUnit);
      const unidad = this.unidadesMedida.find((u) => u.Id === newUnitNumber);
      if (unidad !== undefined) {
        this.unidadMedidaSelected = unidad;
      }

      this.CargarUnidadesMedida();
    },
    SelectCurrency(newUnit) {
      Log(this, this.SelectCurrency.name);
      this.divisa = newUnit;
    },

    ChangePrice(value) {
      Log(this, this.ChangePrice.name);

      const regex = this.productoSelected
        ? new RegExp(`^[0-9]+(\\.[0-9]{0,${this.productoSelected.PrecisionPrecios}})?$`)
        : /^\d+(\.\d{0,2})?$/;
      const valorCorrecto = value.replace(',', '.');
      if (regex.test(valorCorrecto)) {
        if (this.productoSelected != null) {
          this.price = Number.parseFloat(Number.parseFloat(valorCorrecto).toFixed(this.productoSelected.PrecisionPrecios));
        } else {
          this.price = Number.parseFloat(Number.parseFloat(valorCorrecto).toFixed(2));
        }
      }
    },
    actualizarPrecio() {
      if (this.productoSelected != null) {
        this.price = Number.parseFloat(this.price.toFixed(this.productoSelected.PrecisionPrecios));
      } else {
        this.price = Number.parseFloat(Number.parseFloat(this.price).toFixed(2));
      }
    },
    /* resetStepper() {
      // Cambia la clave única para forzar la recreación del f7-stepper
      this.uniqueKey += 1;
    }, */
    async CheckNewLote() {
      Log(this, this.CheckNewLote.name);
      const inputValue = this.$refs.UCLote.GetInputValue();
      if (inputValue !== '') {
        this.loteSelected = { Id: 0, Codigo: inputValue };
      }
    },
    async PressBtnNext() {
      Log(this, this.PressBtnNext.name);
      let faltanDatos = false;
      const emptyFields = [];
      if (this.productoSelected === null) {
        emptyFields.push(this.$t('common.product'));
        this.$refs.UCProducto.ShowWarning();
        faltanDatos = true;
      }
      if (this.envaseSelected === null) {
        this.$refs.UCEnvase.ShowWarning();
        emptyFields.push(this.$t('common.package'));
        faltanDatos = true;
      }
      if (this.tipoPaletSelected === null) {
        this.$refs.UCTipoPalet.ShowWarning();
        emptyFields.push(this.$t('commercialization.common.palletType'));
        faltanDatos = true;
      }

      if (this.almacenSelected === null) {
        this.$refs.UCAlmacenOrigen.ShowWarning();
        emptyFields.push(this.$t('common.warehouse'));
        faltanDatos = true;
      }
      if (this.numEnvases === null) {
        emptyFields.push(this.$t('common.packagesNumber'));
        faltanDatos = true;
      }
      if (this.numPalets === null) {
        emptyFields.push(this.$t('commercialization.common.palletsNumber'));
        faltanDatos = true;
      }
      if (this.price === null) {
        emptyFields.push(this.$t('common.price'));
        faltanDatos = true;
      }

      if (this.loteSelected === null) {
        await this.CheckNewLote();
      }

      if (faltanDatos) {
        const errorMessage = this.$t('commercialization.common.needToFillFields', { text: emptyFields.join(', ') });
        HiNotification.Toast(errorMessage);
      } else {
        this.estadoLineaEditada = false;
        this.estadoLineaCopiada = false;
        const originalIdTemporal = this.idTempral;
        if (this.id === 0 && this.idTempral == null) {
          if (this.palletMixed) {
            if (this.mixedOrderLines === null) {
              this.idTempral = this.actualOrder.lineasPedidoVenta.length;
            } else {
              const objetoMasGrande = this.mixedOrderLines.reduce((maxObjeto, objeto) => {
                if ('IdTemporal' in objeto) {
                  if (!('IdTemporal' in maxObjeto)) {
                    return objeto;
                  }
                  if (objeto.IdTemporal > maxObjeto.IdTemporal) {
                    return objeto;
                  }
                }
                return maxObjeto;
              });
              if (Object.hasOwn(objetoMasGrande, 'IdTemporal')) {
                this.idTempral = objetoMasGrande.IdTemporal + 1;
              } else {
                this.idTempral = 0;
              }
            }
          } else {
            this.idTempral = this.actualOrder.lineasPedidoVenta.length;
          }
        }
        const lineaPedidoVenta = {
          Articulo: this.productoSelected,
          CantidadPales: this.numPalets,
          EnvasesPorPalet: this.numEnvases,
          InfoProducto: this.productoSelected,
          InfoEnvase: this.envaseSelected,
          InfoPale: this.tipoPaletSelected,
          Observaciones: {
            Texto: this.observations,
          },
          AlmacenOrigen: this.almacenSelected,
          PrecioPor: this.unidadMedidaSelected,
          Precio: this.price,
          Id: this.id,
          IdTemporal: this.idTempral,
          Lote: this.loteSelected,
          Marca: this.marcaSelected,
          Confeccion: this.confeccionSelected,
          TipoLinea: 0,
          PaleMixto: 0,
          DatosComplementarios: this.datosComp,
          LineaEditada: false,
        };

        if (lineaPedidoVenta.Id !== 0) {
          lineaPedidoVenta.LineaEditada = true;
        }

        if (!this.palletMixed) {
          const actualOrder = { ...this.actualOrder };
          let cambiado = false;
          if (this.actualOrder.lineasPedidoVenta.length > 0) {
            for (let i = 0; i < this.actualOrder.lineasPedidoVenta.length; i += 1) {
              const element = this.actualOrder.lineasPedidoVenta[i];
              if (!cambiado) {
                if (this.id !== 0 && element.Id === this.id) {
                  actualOrder.lineasPedidoVenta[i] = lineaPedidoVenta;
                  cambiado = true;
                }
                if (this.idTempral != null && element.IdTemporal === this.idTempral) {
                  actualOrder.lineasPedidoVenta[i] = lineaPedidoVenta;
                  cambiado = true;
                }
                if (this.id === 0 && originalIdTemporal == null) {
                  actualOrder.lineasPedidoVenta.push(lineaPedidoVenta);
                  cambiado = true;
                }
              }
            }
          } else {
            actualOrder.lineasPedidoVenta.push(lineaPedidoVenta);
          }
          this.actualOrder = actualOrder;
          this.BackToMain();
        } else {
          let paleMixto = 0;
          if (this.palletMixed /* && !this.estadoLineaMixtaEdit */) {
            const listaOrdenada = { ...this.actualOrder };
            if (listaOrdenada.lineasPedidoVenta.length < 1) {
              paleMixto = 1;
            } else {
              const objetoMasGrande = listaOrdenada.lineasPedidoVenta.reduce((maxObjeto, objeto) => {
                if (objeto.PaleMixto > maxObjeto.PaleMixto) {
                  return objeto;
                }
                return maxObjeto;
              });
              paleMixto = objetoMasGrande.PaleMixto + 1;
            }
          }
          /* if (this.estadoLineaMixtaEdit) {
            paleMixto = this.salesOrderLine.PaleMixto;
          } */
          let actualMixedOrderLines = this.mixedOrderLines;
          if (actualMixedOrderLines == null) {
            actualMixedOrderLines = [];
            lineaPedidoVenta.PaleMixto = paleMixto;
          } else {
            lineaPedidoVenta.PaleMixto = actualMixedOrderLines[0].PaleMixto;
          }

          if (actualMixedOrderLines.length > 0) {
            let cambiado = false;
            for (let i = 0; i < actualMixedOrderLines.length; i += 1) {
              const element = actualMixedOrderLines[i];
              if (!cambiado) {
                if (this.id !== 0 && element.Id === this.id) {
                  actualMixedOrderLines[i] = lineaPedidoVenta;
                  cambiado = true;
                }
                if (this.idTempral != null && element.IdTemporal === this.idTempral) {
                  actualMixedOrderLines[i] = lineaPedidoVenta;
                  cambiado = true;
                }
                if (this.id === 0 && originalIdTemporal == null) {
                  actualMixedOrderLines.push(lineaPedidoVenta);
                  cambiado = true;
                }
              }
            }
          } else {
            actualMixedOrderLines.push(lineaPedidoVenta);
          }

          /* actualMixedOrderLines.push(lineaPedidoVenta); */
          this.mixedOrderLines = actualMixedOrderLines;
          f7.views.main.router.navigate('/newMixtedOrderLine/', {
            ignoreCache: true,
            reloadPrevious: true,
            props: {
              nuevoPedido: this.nuevoPedido,
            },
          });
          await sleep(500);
          f7.views.main.router.back();
        }
      }
    },
    async BackToMain() {
      Log(this, this.BackToMain.name);
      if (this.palletMixed) {
        f7.views.main.router.navigate('/newMixtedOrderLine/', {
          ignoreCache: true,
          reloadPrevious: true,
          props: {
            nuevoPedido: this.nuevoPedido,
          },
        });
        await sleep(500);
        f7.views.main.router.back();
      } else {
        f7.views.main.router.navigate('/orderDetail/', {
          ignoreCache: true,
          reloadPrevious: true,
          props: {
            nuevoPedido: this.nuevoPedido,
            navbarBtn: true,
            mostrarBtnNextAdd: true,
            mostrarOnlyBtnAdd: false,
            mostrarToolbar: false,
          },
        });
        await sleep(500);
        f7.views.main.router.back();
      }
    },
    EventChangeComplementayData(data) {
      const dataClone = structuredClone(deepToRaw(data));
      dataClone.forEach((element) => {
        element.ListaValoresParaSeleccion = [];
        element.Valor = element.Valor.Valor;
      });
      this.datosComp = dataClone;
      if (this.datosComp.length < 1) {
        this.showDataComplementary = false;
      }
    },
    EventProductSelected(obj) {
      Log(this, this.EventProductSelected.name);
      this.doNotChangeNumberOfContainers = false;
      this.productoSelected = obj;
      const block = this.checkBlocks(obj, this.$t('common.article'));
      if (block) {
        this.$refs.UCProducto.Clear();
        return;
      }
      this.$refs.UCProducto.HideWarning();
      if (!this.estadoLineaEditada) {
        this.CargarUnidadesMedida();
      }
      if (!this.commonPackagingSelected) {
        this.setCompositionProduct(obj);
      } else {
        this.commonPackagingSelected = false;
      }

      this.GetPriceXSalesRateXProduction();
    },
    setCompositionProduct(product) {
      Log(this, this.setCompositionProduct.name);
      if (product !== null && product.Composicion != null) {
        let envase = [];
        let pale = [];
        product.Composicion.Componentes.forEach(async (element) => {
          switch (element.Componente.TipoArticulo) {
            case '0':
              pale = element.Componente;
              pale = await this.GetArticles(pale.Id, 0);
              break;
            case '1':
              envase = element.Componente;
              envase = await this.GetArticles(envase.Id, 1);
              if (product.PeticionNumeroSerie) {
                this.ChangeNumEnvases(element.Cantidad);
                if (!element.CantidadVariable) {
                  this.doNotChangeNumberOfContainers = true;
                }
              }
              break;
            default:
              break;
          }
        });
        if (envase != null) {
          this.$refs.UCEnvase.SelectEntity(envase, true);
        }
        if (pale != null) {
          this.$refs.UCTipoPalet.SelectEntity(pale, true);
        }
        if (product.Marca != null) {
          this.$refs.UCMarca.SelectEntity(product.Marca, true);
        } else if (envase && envase.Marca && envase.Marca.Codigo && envase.Marca.Nombre) {
          this.$refs.UCMarca.SelectEntity(envase.Marca, true);
        }
      }
    },
    selectedPackaging(packaging) {
      Log(this, this.selectedPackaging.name);
      this.isCommonPackagingPopupOpened = false;
      this.setConfection(packaging);
    },
    EventConfeccionSelected(obj) {
      Log(this, this.EventConfeccionSelected.name);
      this.confeccionSelected = obj;
      this.setConfection(obj);
      if (!this.estadoLineaEditada) {
        this.CargarUnidadesMedida();
      }
    },
    setConfection(confection) {
      if (confection) {
        let block = false;
        if (confection.Envase) {
          block = this.checkBlocks(confection.Envase, this.$t('common.package'));
          this.$refs.UCEnvase.SelectEntity(confection.Envase, true);
        }
        if (confection.Palet) {
          block = this.checkBlocks(confection.Palet, this.$t('common.pallet'));
          this.$refs.UCTipoPalet.SelectEntity(confection.Palet, true);
        }
        if (confection.Producto) {
          block = this.checkBlocks(confection.Producto, this.$t('common.article'));
          this.commonPackagingSelected = true;
          this.$refs.UCProducto.SelectEntity(confection.Producto, true);
        }
        if (confection.Marca) {
          this.$refs.UCMarca.SelectEntity(confection.Marca, true);
        }
        this.numEnvases = confection.EnvasesPorPalet;

        if (block) {
          this.clearConfection();
        }
      }
    },
    clearConfection() {
      Log(this, this.clearConfection.name);
      this.$refs.UCConfeccion.Clear();
      this.$refs.UCProducto.Clear();
      this.$refs.UCTipoPalet.Clear();
      this.$refs.UCEnvase.Clear();
      this.$refs.UCMarca.Clear();
      this.numEnvases = 0;
    },
    EventEnvaseSelected(obj) {
      Log(this, this.EventEnvaseSelected.name);
      this.envaseSelected = obj;
      const block = this.checkBlocks(obj, this.$t('common.package'));
      if (block) {
        this.$refs.UCEnvase.Clear();
        return;
      }
      this.$refs.UCEnvase.HideWarning();
      if (obj) {
        if (!this.estadoLineaEditada) {
          this.CargarUnidadesMedida();
        }
        if (this.envaseSelected.Marca && this.envaseSelected.Marca.Codigo && this.envaseSelected.Marca.Nombre) {
          this.$refs.UCMarca.SelectEntity(this.envaseSelected.Marca, true);
        }
        this.GetPriceXSalesRateXProduction();
      }
    },
    EventTipoPaletSelected(obj) {
      Log(this, this.EventTipoPaletSelected.name);
      this.tipoPaletSelected = obj;
      const block = this.checkBlocks(obj, this.$t('common.pallet'));
      if (block) {
        this.$refs.UCTipoPalet.Clear();
        return;
      }
      this.$refs.UCTipoPalet.HideWarning();
      if (!this.estadoLineaEditada) {
        this.CargarUnidadesMedida();
      }
    },
    EventAlmacenSelected(obj) {
      Log(this, this.EventAlmacenSelected.name);
      this.almacenSelected = obj;
      this.$refs.UCAlmacenOrigen.HideWarning();
    },
    EventLoteSelected(obj) {
      Log(this, this.EventLoteSelected.name);
      this.loteSelected = obj;
    },
    EventMarcaSelected(obj) {
      Log(this, this.EventMarcaSelected.name);
      this.marcaSelected = obj;
    },
    resetSmartSelect() {
      this.uniqueKey += 1;
    },

    setUnitMeasured(unit) {
      if (this.unidadMedidaSelected !== null) {
        return this.unidadMedidaSelected.Codigo === unit.Codigo;
      }
      return unit.Codigo === 'KG' || unit.Codigo === 'KGR';
    },
    async CargarUnidadesMedida() {
      Log(this, this.CargarUnidadesMedida.name);
      await this.GetUnidadesDeMedida();
      this.resetSmartSelect();
      if (this.unidadMedidaSelected == null) {
        this.unidadesMedida.forEach((element) => {
          if (element.Codigo.toUpperCase() === 'KG' || element.Codigo.toUpperCase() === 'KGR') {
            this.unidadMedidaSelected = element;
          }
        });
        if (this.unidadMedidaSelected === null && this.unidadesMedida.length > 0) {
          this.unidadMedidaSelected = { ...this.unidadesMedida[0] };
        }
      }
    },
    checkBlocks(item, itemType) {
      let hasBlocking = false;
      let tipeOutOfUse = null;
      let tipeBlock = null;
      let tipeWarning = null;
      if (!item) {
        return hasBlocking;
      }
      if (item.Bloqueos) {
        for (const block of item.Bloqueos) {
          if (block.TipoBloqueo === TipoBloqueo.FueraDeUso) {
            tipeOutOfUse = block;
          } else if (block.TipoBloqueo === TipoBloqueo.Bloqueo) {
            tipeBlock = block;
          } else if (block.TipoBloqueo === TipoBloqueo.Aviso) {
            tipeWarning = block;
          }
        }
      }

      if (tipeOutOfUse) {
        hasBlocking = true;
        this.infoSheetParams.opened = true;
        this.infoSheetParams.subtitle1 = tipeOutOfUse.Motivo ?? '';
        this.infoSheetParams.title = `${itemType}: ${this.$t('common.outOfUse')}`;
        this.infoSheetParams.state = 'ERROR';
      } else if (tipeBlock) {
        hasBlocking = true;
        this.infoSheetParams.opened = true;
        this.infoSheetParams.subtitle1 = tipeBlock.Motivo ?? '';
        this.infoSheetParams.title = `${itemType}: ${this.$t('common.block')}`;
        this.infoSheetParams.state = 'ERROR';
      } else if (tipeWarning) {
        this.infoSheetParams.opened = true;
        this.infoSheetParams.subtitle1 = tipeWarning.Motivo ?? '';
        this.infoSheetParams.title = `${itemType}: ${this.$t('common.warning')}`;
        this.infoSheetParams.state = 'CAUTION';
      }
      return hasBlocking;
    },
    selectInputContent(event, elementRef) {
      // auto seleccion del contenido del input, y teclado numerico para el stepper
      nextTick(() => {
        if (event.target.tagName === 'INPUT') {
          if (elementRef && elementRef.$el) {
            const inputElement = elementRef.$refs?.inputEl || elementRef.$el.querySelector('input');
            if (inputElement) {
              inputElement.select();
              inputElement.setAttribute('inputmode', 'numeric');
              inputElement.focus();
            }
          }
        }
      });
    },

    selectPriceByCurrency(price) {
      const itemCurrency = price?.PreciosDivisa?.filter((f) => f.divisa.id === this.divisaSelected.Id);
      if (itemCurrency.length > 0) {
        this.price = itemCurrency[0].precio;
        this.SelectUnitMeasured(price.precioPor?.id);
      }
    },

    setBoxValue(newValue) {
      this.numEnvases = Number.parseInt(newValue, 10);
    },
    setPaletValue(newValue) {
      this.numPalets = Number.parseInt(newValue, 10);
    },
    async GetUnidadesDeMedida() {
      let idProducto = 0;
      let idEnvase = 0;
      let idPale = 0;
      if (this.productoSelected) {
        idProducto = this.productoSelected.Id;
      } else {
        return;
      }
      if (this.envaseSelected) {
        idEnvase = this.envaseSelected.Id;
      }
      if (this.tipoPaletSelected) {
        idPale = this.tipoPaletSelected.Id;
      }
      const result = await APIErp.callGetUnitsMeasuredByItem(idProducto, idEnvase, idPale);

      if (result.status === 200) {
        this.unidadesMedida = [];

        if (result.data.Tag != null) {
          result.data.Tag.forEach((element) => {
            if (element.unidadMedida != null) {
              this.unidadesMedida.push({
                Id: element.unidadMedida.id,
                Codigo: element.unidadMedida.codigo,
                Nombre: element.unidadMedida.nombre,
              });
            }
          });
        }
      }
    },

    async GetPriceXSalesRateXProduction() {
      Log(this, this.GetPriceXSalesRateXProduction.name);
      HiDialog.Preloader(true, this.$t('commercialization.common.updatingPrice'), false);
      if (this.actualOrder.TarifaVenta !== null && this.envaseSelected && this.productoSelected) {
        const result = await APIErp.callPriceXSalesRateXProduction(this.actualOrder.TarifaVenta.Id, this.actualOrder.FechaSalida, this.envaseSelected.Id, this.productoSelected.Id, this.productoSelected.Familia.Id);
        if (result.status === 200) {
          if (result.data?.Tag) {
            this.selectPriceByCurrency(result.data?.Tag);
          }
        }
      }

      HiDialog.Preloader(false);
    },

    GetArticles(idBusqueda, tipoArticulo) {
      callExecuteSPERP(
        'APPERPAGRO_ArticulosXTipoArticulo',
        [
          { NombreParametro: 'filtro', Valor: `Id:${idBusqueda}` },
          { NombreParametro: 'tipoArticulo', Valor: tipoArticulo },
          { NombreParametro: 'idEmpresa', Valor: this.userEnviroment.EntornoDeTrabajo.Empresa.Id },
          { NombreParametro: 'fecha', Valor: new Date() },
          { NombreParametro: 'materiPrimaCheck', Valor: 0 },
        ],
        'Comun.ArticuloJSON',
      ).then((result) => {
        if (result.status !== 200) {
          return null;
        }
        return result.data;
      });
    },
    GetDefaultWarehouse() {
      Log(this, this.GetDefaultWarehouse.name);
      if (this.userEnviroment != null && this.userEnviroment.EntornoDeTrabajo !== null) {
        callFetchWarehousesForEnterpriseGroupsAndLocations({
          filter: `Id:${this.userEnviroment.EntornoDeTrabajo.Almacen.Id}`,
          enterpriseGroupIds: [this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id],
        }).then((result) => {
          if (result.status !== 200) {
            return;
          }
          this.$refs.UCAlmacenOrigen.SelectEntity(result.data[0], true);
        });
      }
    },
    GetDefaultCurrencies() {
      Log(this, this.GetDefaultCurrencies.name);
      callExecuteSPERP(
        'APPERPAGRO_Divisas',
        [],
        'Comun.DivisaJSON',
      ).then((result) => {
        if (result.status !== 200) {
          return;
        }
        const divisas = result.data;
        divisas.forEach((element) => {
          if (this.actualOrder.Cliente.Id_Divisa !== 0) {
            if (element.Id === this.actualOrder.Cliente.Id_Divisa) {
              this.divisaSelected = element;
            }
          } else if (this.userEnviroment.EntornoDeTrabajo.IdDivisaFuncional !== 0) {
            if (element.Id === this.userEnviroment.EntornoDeTrabajo.IdDivisaFuncional) {
              this.divisaSelected = element;
            }
          }
        });
        if (this.divisaSelected === null) {
          this.divisaSelected = { Simbolo: '€' };
        }
      });
    },

  },
};
</script>

<style lang="scss">
.main-FrmOrderCompleteProducto-page {
  .page-content {
    overflow-y: hidden;
  }
  .container-navbar{
    .navbar-inner {
      .title {
          font-size: 16px;
          font-weight: 400;
      }
    }
  }
  .container-toolbar{
    background: var(--f7-bars-bg-color);
    .content-toolbar {
      --f7-tabbar-link-active-color: var(--his-whispering-lilac);
      --f7-tabbar-link-active-bg-color: var(--his-mora-white);
      --f7-tabbar-link-inactive-color: #fff;
      --toolbar-bg-color: var(--his-tierra-grey);

      width: 100%;
      padding-left: 10px;
      padding-right: 10px;
      margin-top: -1px;
      padding-top: 5px;
      .content-toolbar-elements {
        position: inherit;
        height: 50px;
        border-radius: 6px;
        margin-bottom: 12px;
        .toolbar-inner {
          padding: 7px;
          .tab-link{
            border-radius: 6px!important;
            .content-title{
              color: var(--his-darkness);
            }
          }
        }
      }
      .tabs{
        background: var(--f7-page-bg-color);
        margin: 0px -10px 0px -10px;
        height: calc(100vh - 185px);
        overflow-y: scroll;
        .tab{
          --search-title-color: var(--his-metal-dark);
          height: 100%;
        }
      }

      &__detail{
        &--steppers{
          margin-top: 16px;
          display: flex;
          justify-content: space-evenly;
          .stepper{
            height: var(--search-input-height);
            display: flex;
            justify-content: center;
            .stepper-button-minus{
              border-top-left-radius: var(--search-input-border-radius);
              border-bottom-left-radius: var(--search-input-border-radius);
            }
            .stepper-button-plus{
              border-top-right-radius: var(--search-input-border-radius);
              border-bottom-right-radius: var(--search-input-border-radius);
            }
            .stepper-input-wrap{
              width: 100%;
              background-color: var(--his-mora-white);
              input{
                height: var(--search-input-height);
                width: 100%;
                text-align: center;
                font-weight: 600;
                font-size: 18px;
              }
            }
          }
        }
        &--price{
          margin-top: 16px;
          display: flex;
          justify-content: space-evenly;
          &__item{
            max-width: 290px;
          }
          .list{
            margin: 0px;
            ul::before{
              content: none;
            }
            ul::after{
              content: none;
            }
            .item-content{
              padding-left: 0px;
              .item-inner{
                padding-right: 0px;
                .item-input-wrap{
                  input{
                    padding-left: 10px;
                    height: var(--search-input-height);
                    font-weight: 600;
                    border-radius: var(--search-input-border-radius);
                    border: var(--search-input-border);
                  }
                }
              }
            }
            .item-link{
              .item-content{
                padding-left: 0px;
                border-radius: var(--search-input-border-radius);
                border: var(--search-input-border);
                height: var(--search-input-height);
                font-weight: 600;
                .item-inner{
                  .item-after{
                    font-weight: 600;
                  }
                }
              }
            }
          }
        }
      }
      &__other {
        &--obs-title{
          margin-left: 8px;
        }
        .text-editor{
          min-height: 200px;
          margin: 0px;
          border-radius: var(--search-input-border-radius);
          border: var(--search-input-border);
        }
        .container-complementary-data{
          --f7-list-item-title-text-color: var(--his-tierra);
          color: var(--search-title-color);
          margin: 16px;
          margin-left: 0px;
          margin-right: 0px;
          .accordion-item{
            border-radius: var(--search-input-border-radius);
            border: var(--search-input-border);
            .item-link{
              .item-content{
                margin-left: 0px;
                padding-left: 0px;
                .item-inner{
                  background-color: #fff;
                  border-radius: var(--search-input-border-radius);
                  .item-title{
                    margin-left: var(--search-title-margin-left);
                    color: var(--search-title-color);
                    font-size: var(--search-title-font-size);
                    font-weight: var(--search-title-weight);
                  }
                }
              }
            }

            .accordion-item-content{
              .content-data-list{
                .list{
                  span{
                    margin: var(--search-title-margin);
                    color: var(--search-title-color);
                    font-size: 14px;
                    font-weight: var(--search-title-weight);
                  }
                  .input-normal{
                    margin-top: 0px;
                    .item-content{
                      padding-left: 0px;
                      .item-inner{
                        padding-right: 0px;
                        input{
                          border-radius: var(--search-input-border-radius);
                          border: var(--search-input-border);
                          height: 46px;
                          color: var(--his-tierra);
                          font-size: var(--search-input-font-size);
                          padding: var(--search-input-padding);
                        }
                      }
                    }
                  }
                  .content-searcher-erp{
                    margin-right: 0px;
                    margin-left: 0px;
                    input{
                      border-radius: var(--search-input-border-radius);
                    }
                  }
                  .container-data{
                    height: 75px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .content-button {
    --f7-button-font-size: 16px;
    position: fixed;
    width: 100%;
    bottom: 0;
    border-top: 1px solid var(--his-silver);
    background-color: #fff;
    height: 70px;
    &__save{
      margin: 10px 20px 10px 20px;
      height: 50px;
      background-color: var(--his-melon)
    }
  }
}
</style>
